<style lang="scss" scoped>
  @import "../../../../assets/scss/mixins";

  $leftWidth: 220px;

  .el-form .el-checkbox__label {
    font-size: 12px;
    padding-left: 5px;
  }

  .el-form .el-checkbox__inner {
    width: 14px;
    height: 14px;
  }

  .content-part {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;

    .content-left {
      width: $leftWidth;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      text-align: left;
      background-color: #eef2f3;

      > ul {
        margin: 0;
      }

      > h2 {
        padding: 0;
        margin: 0;
        font-size: 18px;
        font-weight: bold;
        line-height: 55px;
        border-bottom: 1px solid #ddd;
        background-color: #eef2f3;
      }

      .list-style {
        cursor: pointer;
        padding: 10px;
        text-align: center;

        span {
          display: inline-block;
          padding: 8px 35px;
        }

        &.active {
          span {
            background-color: $activeColor;
            border-radius: 20px;
            color: $activeColorFont
          }
        }

        &:hover {
          background: #dee9eb
        }

      }

    }

    .content-right {
      > h3 {
        padding: 0;
        margin: 0 0 20px;
        font-size: 18px;
        font-weight: normal;
        line-height: 55px;
        height: 55px;
        border-bottom: 1px solid #ddd;
        text-align: center;
        position: fixed;
        top: 0;
        right: 0;
        left: $leftWidth;
        background: #fff;
        z-index: 2;
      }

      position: absolute;
      top: 0;
      left: $leftWidth;
      right: 0;
      bottom: 0;
      overflow: auto;
      /*.hide-content {*/
      /*display: none;*/
      /*}*/
      /*.show-content {*/
      /*display: block;*/
      /*}*/
    }

    .btn-submit-save {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      text-align: center;
      padding: 15px;
    }

    .min-gutter {
      .el-form-item {
        /*margin-bottom: 20px;*/
      }

      .el-form-item__label {
        font-size: 12px
      }
    }

    .qp-box {
      margin-bottom: 5px;
      padding: 4px;
      box-shadow: 0 2px 1px 0 #ddd;
    }
  }

  .el-form .el-select {
    display: block;
  }

  .el-form .el-date-editor {
    display: block;
  }

  .title-link {
    position: absolute;
    top: -10px;
    left: 5px;
    padding: 0;
  }

</style>
<template>
  <div>
    <div class="content-right min-gutter">
      <h3>{{!form.id ? '添加' : '编辑'}}货品电子监管码</h3>
      <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px"
                 @submit.prevent="onSubmit('form')" onsubmit="return false" style="padding-right: 20px">
          <el-form-item label="货品" prop="operateGoodsId">
            <el-select placeholder="请输入名称搜索货品" v-model="form.operateGoodsId" filterable remote
                       :remote-method="queryManageGoods" :clearable="true"
                       popperClass="custom-select">
              <el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in manageGoods">
                <manage-goods-option :optionItem="item"/>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电子监管码" prop="resourceCode">
            <oms-input type="text" v-model="form.resourceCode" placeholder="电子监管码"></oms-input>
          </el-form-item>
          <el-form-item label="包装层级" prop="packageScheme">
            <oms-input type="number" v-model="form.packageScheme" placeholder="包装层级" min="1"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('form')" native-type="submit" :disabled="doing">保存
            </el-button>
            <el-button @click="doClose">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script type="text/jsx">
  import {electronCode} from '@/resources';
  import ScrollMixin from '@/mixins/scrollMixin';
  import methodsMixin from '@/mixins/methodsMixin';

  export default {
    mixins: [ScrollMixin, methodsMixin],
    data: function () {
      return {
        form: {
          operateGoodsId: '',
          resourceCode: ''
        },
        rules: {
          operateGoodsId: [
            {required: true, message: '请选择货品', trigger: 'change'}
          ],
          resourceCode: [
            {required: true, message: '请输入电子监管码', trigger: 'blur'}
          ],
          packageScheme:[
            {required: true, message: '请输入包装层级', trigger: 'blur'}
          ]
        },
        goodsList: [], // oms货品列表
        doing: false,
        customerList: [],
        loading: false
      };
    },
    props: ['formItem',],
    mounted: function () {
    },
    computed: {},
    watch: {
      formItem: function (val) {
        if (!val.id) {
          this.form = {
            operateGoodsId: '',
            resourceCode: ''
          };
        } else {
          this.manageGoods = [
            {
              id: val.operateGoodsId,
              name: val.goodsName,
              specifications: val.specification,
              code: val.goodsCode
            }
          ];
          this.form = Object.assign({}, val);
        }
        this.$nextTick(() => {
          this.$refs['form'] && this.$refs['form'].clearValidate();
        });
      }
    },
    methods: {
      onSubmit: function (formName) {
        this.$refs[formName].validate((valid) => {
          if (!valid || this.doing) return;
          this.doing = true;
          this.manageGoods.forEach(i => {
            if (i.id === this.form.operateGoodsId) {
              this.form.goodsId = i.goodsId;
            }
          });
          if (!this.form.id) {
            electronCode.save(this.form).then(() => {
              this.doing = false;
              this.$notify.success({
                duration: 2000,
                name: '成功',
                message: '新增成功'
              });
              this.$emit('change', this.form);
              this.$emit('right-close', this.form);
            }).catch(error => {
              this.$notify.error({
                duration: 2000,
                message: error.response.data && error.response.data.msg || '新增失败'
              });
              this.doing = false;
            });
          } else {
            electronCode.update(this.form).then(() => {
              this.doing = false;
              this.$notify.success({
                duration: 2000,
                name: '成功',
                message: '编辑成功'
              });
              this.$emit('change', this.form);
              this.$emit('right-close', this.form);
            }).catch(error => {
              this.$notify.error({
                duration: 2000,
                message: error.response.data && error.response.data.msg || '编辑失败'
              });
              this.doing = false;
            });
          }
        });
      },
      doClose: function () {
        this.$emit('right-close');
        this.$refs['form'].resetFields();
      }
    }
  };
</script>
